<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm ref="formMergeLangs" @submit="formSubmit($event, 'mergeLangs')">
            <CSelect
                :label="$t('lang')"
                :placeholder="$t('select_a_lang')"
                :options="locales"
                :value.sync="langId"
                :disabled="true"
            >
            </CSelect>
            <CSelect
                :label="$t('lang_to_merge')"
                :placeholder="$t('select_a_lang_to_merge')"
                :options="locales"
                :value.sync="langIdToMerge"
            >
                <template #description>
                    <span>{{ $t("lang_to_merge_description") }}</span>
                </template>
            </CSelect>

            <ButtonLoading
                type="submit"
                :block="true"
                color="primary"
                :loading="forms.mergeLangs._loading"
            >
                <span>{{ $t("merge_lang") }}</span>
            </ButtonLoading>
        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("cancel") }}
            </CButton>
            <ButtonLoading
                color="success"
                @click="executeSubmitForm"
                :loading="forms.mergeLangs._loading"
            >
                {{ $t("merge_lang") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
import formMixin from "~/mixins/form";
import modalComponentMixin from "~/mixins/modalComponent";
import { validationMixin } from "vuelidate";
import { required, sameAs } from "vuelidate/lib/validators";
import ButtonLoading from "~/components/ButtonLoading.vue";
export default {
    name: "MergeLangsModal",
    mixins: [formMixin, validationMixin, modalComponentMixin],
    components: {
        ButtonLoading,
    },
    data() {
        return {
            locales: [],
            langId: null,
            langIdToMerge: null,
            forms: {
                mergeLangs: {
                    name: null,
                    translations: {},
                    _loading: false,
                },
            },
        };
    },

    validations: {
        forms: {
            mergeLangs: {
                name: {
                    required,
                },
            },
        },
    },

    watch: {
        show() {
            this.showComponent = this.show;
            if (!this.show) {
                this.resetForm("mergeLangs");
                this.$v.$reset();
            }
        },
        dataComponent() {
            if (this.dataComponent.locales)
                this.locales = this.dataComponent.locales;
            if (this.dataComponent.langId){
                this.langId = this.dataComponent.langId;
            }
        },
    },

    methods: {
        async formSubmit(e, formName) {
            e.preventDefault();
            try {
                this.forms.mergeLangs._loading = true;
                if (this.langIdToMerge) {
                    let dataToMerge = await this.fetcher({
                        baseURL: process.env.VUE_APP_LANGS_BUCKET,
                        url: this.langIdToMerge + ".json",
                        headers: {
                            "Cache-Control": "no-cache",
                        },
                    });
                    this.forms.mergeLangs.translations = {
                        ...this.forms.mergeLangs.translations,
                        ...dataToMerge
                    };
                }
                if (this.langId) {
                    let data = await this.fetcher({
                        baseURL: process.env.VUE_APP_LANGS_BUCKET,
                        url: this.langId + ".json",
                        headers: {
                            "Cache-Control": "no-cache",
                        },
                    });
                    this.forms.mergeLangs.translations = {
                        ...this.forms.mergeLangs.translations,
                        ...data
                    };
                }

                this.forms.mergeLangs.name = this.langId;
                let response = await this.fetcher({
                    baseURL: process.env.VUE_APP_API_CORE,
                    url: `/langs/${this.forms.mergeLangs.name}`,
                    method: "PUT",
                    data: this.forms.mergeLangs.translations,
                });
                this.forms.mergeLangs._loading = false;
                this.showComponent = false;
                this.showMessageSuccess();
            } catch (error) {
                this.showMessageError(error);
            }

            this.$emit("submit", formName);
        },

        executeSubmitForm() {
            this.$refs.formMergeLangs.requestSubmit();
        },
    },
};
</script>

<style>
</style>